// React Query keys for the handoff board (under ['shop', id] so shop-wide invalidation reaches them).
export const handoffKeys = {
  board: (shopId: string) => ['shop', shopId, 'handoff'] as const,
};
